import {apiPOST} from "./RequestsCore";

/**
 * This method receives a JSON object with all dynamic information about expedient, and stores all those values.
 * Works by deleting all existing formValues in database and storing these new ones provided in json param.
 *
 * @param json
 * @param expedient_id
 * @returns {Promise<AxiosResponse<*>>}
 */
export async function storeFormValues(json, expedient_id) {
    let data = {
        form_values: json
    }

    return await apiPOST('/api/expedient/' + expedient_id + '/form-values', data);
}
